import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon54: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#FFD147"
        d="M2.5 5.5A5.503 5.503 0 0 1 8.538.025c2.82.27 4.962 2.78 4.962 5.69v4.276l.491.001C15.1 9.992 16 10.892 16 12v4.02a3.973 3.973 0 0 1-3.973 3.973H3.973A3.973 3.973 0 0 1 0 16.02V12c0-1.108.9-2.008 2.009-2.008H10.5V5.493A2.499 2.499 0 0 0 8.164 3L8 2.994a2.5 2.5 0 0 0-2.5 2.5V6.5a1.5 1.5 0 0 1-3 0v-1Zm11.491 5.492h-.958l-.033.002h-.034l-1.933-.003-.033.003h-.034l-8.957-.002C1.452 10.992 1 11.444 1 12v4.02a2.974 2.974 0 0 0 2.973 2.973h8.054A2.974 2.974 0 0 0 15 16.02V12c0-.556-.452-1.008-1.009-1.008ZM8 12.994a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5Zm.444-11.973A4.502 4.502 0 0 0 3.5 5.501v1a.5.5 0 0 0 1 0V5.493a3.5 3.5 0 1 1 7 0v4.497h1V5.715c0-2.335-1.659-4.35-3.849-4.669l-.207-.025Z"
      />
    </Svg>
  )
}
